<template>
  <span :id="el.id">
    <template v-if="customMode">
      <form
        v-if="el.type === 'input' || el.type === 'custinput'"
        class="drag-item cursor"
        :style="{
          transformOrigin: 'top left',
          transform: `scale(${el.scale})`,
          boderColor: `${color}`,
          position: 'absolute',
          width: `${el.width}px`,
          top: `${el.top}px`,
          left: `${el.left}px`,
          zIndex: 1,
          '--current-outline': `${color}`,
        }"
        v-drag
        @v-drag-end="onDragEnd"
        @click="onFocus"
      >
        <div
          v-if="el.required"
          style="
            color: red;
            height: 26px;
            font-size: 22px;
            position: absolute;
            left: -12px;
            top: 0;
          "
        >
          *
        </div>

        <input
          class="cs-input"
          :style="{
            fontFamily: `'${el.font}', sans-serif`,
            outlineColor: `${color}`,
            textAlign: el.font === 'arialunicode' ? 'right' : 'left',
            color: `${color}`,
            fontSize: `${el.size}`,
            backgroundColor: 'white',
          }"
          :placeholder="parsed_name"
        />
        <button @click.prevent="onRemove" class="cursor p-close">X</button>
      </form>
      <span
        v-else
        class="drag-item cursor"
        v-drag
        @v-drag-end="onDragEnd"
        @click="onFocus"
        :style="{
          background: 'rgba(255, 255, 255, 0.1)',
          borderRadius: '3px',
          transformOrigin: 'top left',
          transform: `scale(${el.scale})`,
          border: `2px solid ${color}`,
          position: 'absolute',
          width: `${el.width}px`,
          textAlign: el.font === 'arialunicode' ? 'right' : 'left',
          top: `${el.top}px`,
          left: `${el.left}px`,
          zIndex: 1,
        }"
      >
        <div
          v-if="el.required"
          style="
            color: red;
            height: 26px;
            font-size: 22px;
            position: absolute;
            left: -12px;
            top: 0;
          "
        >
          *
        </div>
        <span
          :style="{
            fontSize: `${el.size}`,
            fontFamily: `'${el.font}', sans-serif`,
            color: `${color}`,
          }"
          >{{ parsed_value }}</span
        >
        <button @click.prevent="onRemove" class="cursor p-close">X</button>
      </span>
    </template>
    <template v-else>
      <form
        v-if="el.type === 'input'"
        class="input-def"
        :style="{
          '--current-outline': `${color}`,
          transformOrigin: 'top left',
          transform: `scale(${el.scale})`,
          width: `${el.auto_expand ?  `auto` : `${el.width}px`}`,
          boder: 'none',
          position: 'absolute',

          top: `${el.top}px`,
          left: `${el.left}px`,
          zIndex: 1,
        }"
      >
        <div
          v-if="el.required"
          style="
            color: red;
            height: 26px;
            font-size: 22px;
            position: absolute;
            left: -12px;
            top: 0;
          "
        >
          *
        </div>

        <input
          class="cs-input"
          :style="{
            fontFamily: `'${el.font}', sans-serif`,
            outlineColor: `${color}`,
            color: `${color}`,
            textAlign: el.font === 'arialunicode' ? 'right' : 'left',
            fontSize: `${el.size}`,
            backgroundColor: 'whiter',
          }"
          v-model="el.value"
          @input="inputted"
          :placeholder="el.name"
        />
      </form>
      <span
        v-else
        class="input-def"
        :style="`position: absolute;transform: scale(${el.scale});font-size:${
          el.size
        };transform-origin: top left; top:calc(${el.top}px + 16px - ${el.size}px); left:${el.left};width: ${el.auto_expand ?  `auto` : `${el.width}px`}; z-index: 1;text-align: ${el.font === 'arialunicode' ? 'right' : 'left'}`"
      >
        <div
          v-if="el.required"
          style="
            color: red;
            height: 26px;
            font-size: 22px;
            position: absolute;
            left: -12px;
            top: 0;
          "
        >
          *
        </div>
        <span
          :style="{
            fontFamily: `'${el.font}', sans-serif`,
            fontSize: `${el.size}`,
            color: `${color}`,
          }"
          >{{ el.value }}</span
        >
      </span>
    </template>
  </span>
</template>

<script>
import mixins from "./mixins";

export default {
  mixins: [mixins],
  computed: {
    parsed_value() {
      return this.el.value !== null &&
        this.el.value !== undefined &&
        typeof this.el.value === "object"
        ? this.el.value.value ?? this.el.value.fieldKey
        : this.el.value;
    },
    parsed_name() {
      return this.el.name !== null &&
        this.el.name !== undefined &&
        typeof this.el.name === "object"
        ? this.el.name.value ?? this.el.name.fieldKey
        : this.el.name;
    },
  },

  mounted() {
    console.log("inn mounted ",this.el)
  },

  methods: {
    inputted(ev) {
      ev.target.closest(".input-def").style.width = ev.target.value.length * 8 + "px";
    },
  },
};
</script>

<style scoped>
::-webkit-input-placeholder {
  /* WebKit, Blink, Edge */
  color: var(--current-outline);
}

:-moz-placeholder {
  /* Mozilla Firefox 4 to 18 */
  color: var(--current-outline);
  opacity: 1;
}

::-moz-placeholder {
  /* Mozilla Firefox 19+ */
  color: var(--current-outline);
  opacity: 1;
}

:-ms-input-placeholder {
  /* Internet Explorer 10-11 */
  color: var(--current-outline);
}

::-ms-input-placeholder {
  /* Microsoft Edge */
  color: var(--current-outline);
}

::placeholder {
  /* Most modern browsers support this now. */
  color: var(--current-outline);
}

@font-face {
  font-family: "snell";
  src: url("/fonts/SnellBT-Regular.otf") format("opentype"),
    url("/fonts/SnellBT-Regular.otf") format("truetype"),
    url("/fonts/SnellBT-Regular.otf") format("woff"),
    url("/fonts/SnellBT-Regular.otf") format("embedded-opentype"),
    url("/fonts/SnellBT-Regular.otf") format("svg");
}

@font-face {
  font-family: "kaufmann";
  src: url("/fonts/KAUFMANN.TTF");
}

@font-face {
  font-family: "brushsci";
  src: url("/fonts/BRUSHSCI.ttf");
}

@font-face {
  font-family: "maturasc";
  src: url("/fonts/MATURASC.TTF");
}

@font-face {
  font-family: "lucida-call";
  src: url("/fonts/lucida calligraphy italic.ttf");
}

@font-face {
  font-family: "zapfino";
  src: url("/fonts/ZapfinoExtraLT-One.otf");
}

@font-face {
  font-family: "chinese";
  src: url("/fonts/chinese.stxingka.ttf");
}

@font-face {
  font-family: "lucida-black";
  src: url("/fonts/Lucida Blackletter Regular.ttf");
}
</style>
